export var BillChargeKind;
(function (BillChargeKind) {
    BillChargeKind["Service"] = "SERVICE";
    BillChargeKind["Vat"] = "VAT";
    BillChargeKind["Discount"] = "DISCOUNT";
    BillChargeKind["Other"] = "OTHER";
})(BillChargeKind || (BillChargeKind = {}));
//# sourceMappingURL=bill-charge-kind.enum.js.map